import styles from "./style.module.scss";
import sadUserIMG from "assets/pngImages/sad-user.png";

export const NoViewsComponent = () => {
  return (
    <div className={styles.noViewsContainer}>
      <div className={styles.image}>
        <img src={sadUserIMG} alt="User with no views" />
      </div>
      <div className={styles.title}>No Views Found</div>
      <div className={styles.subTitle}>
        You haven’t created any view. Please create one to view it here.{" "}
      </div>
    </div>
  );
};
